var validateInput = function validateInput(input, regexPattern) {
  var regex = new RegExp(regexPattern);
  return regex.test(input);
};
var vinPattern = /^[A-HJ-NPR-Za-hj-npr-z\d]{8}[\dX][A-HJ-NPR-Za-hj-npr-z\d]{2}\d{6}$/;
var checkIsVin = function checkIsVin(input) {
  return validateInput(input, vinPattern);
};

export { checkIsVin, validateInput };
